import axios from 'axios';
import authHeader from './auth-header';
import { getUrl } from './service-utils';
import { IAddActivityModel } from '../components/modals/activity/use-add-activity';

const API_URL = getUrl();

export const getFolderActivities = async (id: string) => {
  const tmpData = await axios.get(API_URL + 'folders/' + id, {
    headers: authHeader()
  });
  return tmpData.data.data.activities;
};

export const getActivity = async (id: string) => {
  const tmpData = await axios.get(API_URL + 'activities/' + id, {
    headers: authHeader()
  });
  return tmpData.data.data;
};
